import * as React from 'react';
import styled from 'styled-components';
import ArrowPointer from '../atoms/ArrowPointer';

const normalizeTitle = (title: string | null | undefined) =>
  (title || '').trim().toLowerCase();

const ArrowPointerBlock = ({
  process,
  currentStatus,
  index,
}: Props) => {
  const current = normalizeTitle(currentStatus);
  const subProcess = current
    ? process.statuses.find(el => normalizeTitle(el) === current)
    : undefined;
  const isTitleActive = !!subProcess;

  return (
    <ArrowBlockWrapper
      isWide={process.statuses.length >= 3}
    >
      <ArrowPointer
        size="large"
        active={isTitleActive}
        index={index}
      >
        <p style={{ margin: 0 }}>{process.title}</p>
        {subProcess && (
          <p style={{ margin: 0, fontSize: 13 }}>
            {`(${subProcess})`}
          </p>
        )}
      </ArrowPointer>
    </ArrowBlockWrapper>
  );
};

const ArrowBlockWrapper = styled.div<WrapperProps>`
  // width: ${({ isWide }) => (isWide ? '30' : '23')}%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// const ArrowsSmallBlock = styled.div`
//   display: flex;
//   justify-content: center;
//   flex-wrap: wrap;
// `;

interface Props {
  process: Process;
  // Permit Status title, e.g. "Inspection Started".
  currentStatus: string | null;
  index: number;
}

interface Process {
  title: string;
  statuses: string[];
}

interface WrapperProps {
  isWide: boolean;
}

export default ArrowPointerBlock;
